export const pricing = {
	title: "PRECIFICAÇÃO",
	fields: {
		saleType: {
			label: "Tipo de venda",
			placeholder: "Unidade",
			options: {
				unit: "Unidade",
				gram: "Gramas",
				liter: "Litros",
				variable: "Preço Variável",
			},
		},
		unitOfMeasure: {
			label: "Unidade de medida",
			placeholder: "Grama",
			fixedUnit: "Unidade (1)",
			options: {
				gramas: "Gramas",
				ml: "Mililitros",
			},
		},
		quantity: {
			label: "Quantidade",
			placeholder: "100",
		},
		price: {
			label: "Preço",
			placeholder: "00,00",
			tooltip: "Preço opcional, Você pode definir ou alterar-lo no PDV",
		},
	},
	variablePriceInfo: {
		title: "Preço definido no PDV",
		description:
			"Produtos com preço variável não possuem valor fixo. O preço é informado no PDV no momento da venda.",
	},
};
